import styled from '@emotion/styled'

export const BookkeepersEmptyView = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`
